const FilledAlertCircleIcon = (props) => {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" {...props}>
      <path
        d="M9.187 3.305A6.83 6.83 0 0 0 6.27 4.401C4.637 5.496 3.583 7.261 3.363 9.27c-.047.428-.02 1.304.053 1.713.324 1.823 1.267 3.327 2.753 4.392.405.29 1.242.712 1.728.87 1.685.548 3.459.427 5.02-.343a6.633 6.633 0 0 0 3.536-4.332 6.535 6.535 0 0 0-.137-3.763c-.815-2.449-2.953-4.185-5.548-4.505a9.934 9.934 0 0 0-1.581.003m1.107 2.819a.596.596 0 0 1 .303.41c.048.209.048 3.375 0 3.6a.613.613 0 0 1-1.214-.077 48.37 48.37 0 0 1-.01-1.874c.012-1.893.002-1.818.244-2.002.201-.153.431-.172.677-.057m.094 5.646c.58.299.578 1.162-.004 1.462a.874.874 0 0 1-.794-.009c-.751-.442-.419-1.59.448-1.546a.91.91 0 0 1 .35.093"
        fillRule="evenodd"
      />
    </svg>
  );
};

export { FilledAlertCircleIcon };
